import type { Dispatch, UnknownAction } from '@reduxjs/toolkit'

import { discrepanciesReloadRequested, incidentsReloadRequested, recoveryProofReloadRequested } from './commands'
import { discrepancyLimitChosen, incidentsPageAdvanced, incidentsPageReturned, incidentsRestarted } from './incidentsSlice'
import type {
  DiscrepanciesActions,
  IncidentsActions,
  IncidentsVm,
  RecoveryProofActions,
  RecoveryProofVm,
} from './types'

/** Переходы журнала инцидентов — их даёт binding (окна — забота оболочки, не пакета). */
export interface IncidentsNavigation {
  openProof: (saleId: string) => void
  openRmk: () => void
}

/**
 * Действия журнала инцидентов → намерение и чтения. Курсор следующей страницы
 * берётся из ответа сервера (`nextCursor`), а не строится клиентом.
 */
export function createIncidentsActions(
  vm: IncidentsVm,
  dispatch: Dispatch<UnknownAction>,
  navigation: IncidentsNavigation,
): IncidentsActions {
  const ref = vm.seat === null ? null : { resourceId: vm.resourceId, registerKey: vm.seat.registerKey }
  return {
    reload: () => dispatch(incidentsReloadRequested({ resourceId: vm.resourceId, registerKey: vm.seat?.registerKey ?? null })),
    next: () => {
      if (ref !== null && vm.nextCursor !== null) dispatch(incidentsPageAdvanced({ ...ref, cursor: vm.nextCursor }))
    },
    prev: () => {
      if (ref !== null && vm.canPrev) dispatch(incidentsPageReturned(ref))
    },
    restart: () => {
      if (ref !== null) dispatch(incidentsRestarted(ref))
    },
    openProof: navigation.openProof,
    openRmk: navigation.openRmk,
  }
}

export function createRecoveryProofActions(
  vm: RecoveryProofVm,
  dispatch: Dispatch<UnknownAction>,
  navigation: { openResolve: (operationId: string) => void; close: () => void },
): RecoveryProofActions {
  return {
    reload: () => dispatch(recoveryProofReloadRequested({ resourceId: vm.resourceId, saleId: vm.saleId })),
    openManualResolve: () => {
      if (vm.manualOperationId !== null) navigation.openResolve(vm.manualOperationId)
    },
    close: navigation.close,
  }
}

export function createDiscrepanciesActions(resourceId: string, dispatch: Dispatch<UnknownAction>): DiscrepanciesActions {
  return {
    reload: () => dispatch(discrepanciesReloadRequested({ resourceId })),
    limitChanged: (limit) => dispatch(discrepancyLimitChosen({ resourceId, limit })),
  }
}
